module.exports = __webpack_public_path__ + "static/how-to-talk-so-kids-will-listen--listen-so-kids-will-talk-69829b355271f2e7c0f70c9cfc615bfa.jpg";